import script from "./PrintFriendlyResults.vue?vue&type=script&lang=js"
export * from "./PrintFriendlyResults.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__